import styled from 'styled-components';
import { badgeBaseStyles, bannerStatusStyles } from '@/modules/jackpot/styles';
import { device, hexToRGB } from '@/styles/helpers';

export const ScPools = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 24px;
  width: 100%;

  @media (${device.mobile}) {
    display: none;
  }
`;

export const ScPool = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  flex: 1;

  ${bannerStatusStyles}

  & .inner {
    display: flex;
    align-items: center;
    height: 100%;
    gap: 4px;
  }

  & .bottom {
    display: flex;
    align-items: center;
    gap: 8px;
    flex-wrap: wrap;
  }

  & .hit-range {
    color: rgba(255, 255, 255, 0.8);
    font-size: 12px;
    line-height: 18px;
    font-weight: 400;
    letter-spacing: 0;
    text-transform: none;
    white-space: nowrap;
  }

  & .badge {
    ${badgeBaseStyles}
    text-transform: none;
    white-space: nowrap;
  }

  & .icon {
    width: 72px;
    height: 72px;
  }
`;

export const ScPoolInfo = styled.div`
  font-weight: bold;
  line-height: 1.25;
  text-transform: uppercase;
  display: flex;
  flex-direction: column;
  justify-content: center;

  & .title {
    font-size: 16px;
    letter-spacing: 0.01em;
    color: ${({ theme }) => hexToRGB(theme.whiteColor, 0.6)};
    white-space: nowrap;
  }

  & .prize {
    font-size: 32px;
    letter-spacing: 0.03em;
    color: ${({ theme }) => theme.whiteColor};
    text-transform: none;
    white-space: nowrap;
  }
`;
